<script setup lang="ts">
import { computed } from 'vue'

import { BauerProductCard, PurchaseOptions, SUPPORTED_MARKETS } from '@toni/commerce-api-types'

import PurchaseOption from '../PurchaseOption.vue'
import ProductLabel from '../ProductLabel.vue'
import ImageGallery from '../ImageGallery.vue'
import AffiliateLink from '../AffiliateLink.vue'

const props = withDefaults(defineProps<{
  productCard: BauerProductCard,
  purchaseOptions: PurchaseOptions,
  embedded?: boolean
}>(), {
  purchaseOptions: undefined,
  embedded: true
})

const purchaseOptions = computed(() => props.purchaseOptions || [])

const primaryPurchaseOption = purchaseOptions.value[0]
const alternativePurchaseOptions = purchaseOptions.value.slice(1)

const images = computed(() => props.productCard.images?.filter((image) => !image.isHidden))
</script>

<template>
  <div :class="`p-4 ${embedded ? '' : 'border-solid border-2 shadow-lg'}`">
    <AffiliateLink v-if="productCard.intendedUses?.some((el) => el.market && el.market === SUPPORTED_MARKETS.DE)"
                   class="pb-3" />
    <div class="grid col-span-2 gap-7">
      <ProductLabel v-if="productCard?.label"
                    :text="productCard?.label"
                    :highlight="false"
                    :invert-text="false" />
      <h3 class="font-heading text-center text-heading-sm text-foreground md:text-heading-lg">
        {{ productCard.title }}
      </h3>
      <ImageGallery v-if="images && images.length > 0"
                    :images="images" />
      <div class="flex flex-col justify-between gap-2.5">
        <PurchaseOption v-if="primaryPurchaseOption"
                        :purchase-option="primaryPurchaseOption"
                        variant="highlighted"
                        :purchase-option-position="1" />
        <PurchaseOption v-for="(alternate, index) in alternativePurchaseOptions"
                        :key="alternate.merchant.name || index"
                        :purchase-option="alternate"
                        :purchase-option-position="index + 2" />
      </div>
    </div>
  </div>
</template>
